import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteProductComment } from "./deleteProductComment.request";

const useDeleteProductComment = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteProductComment,
    onError: toastServerError,
    ...options
  });
};

export default useDeleteProductComment;
